import { call, put, takeLatest, all } from 'redux-saga/effects';
import request from 'utils/request';
import { FETCH_TOKEN_DETAILS_REQUEST } from './constants';
import { GET_USER_TOKEN_DETAILS } from '../../utils/urls';
import { authFailure, tokenDetailsSuccess, tokenDetailsFailure } from './actions';

export function* getUserTokenDetails() {
  const requestURL = GET_USER_TOKEN_DETAILS;

  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {},
  };

  try {
    const response = yield call(request, requestURL, requestOptions);
    if (response.user_id) {
      yield put(tokenDetailsSuccess(response));
    } else {
      yield put(tokenDetailsFailure(response));
    }
  } catch (err) {
    if (
      err.response &&
      (err.response.status === 401 || err.response.status === 403)
    ) {
      yield put(authFailure());
    } else {
      yield put(tokenDetailsFailure(err));
    }
  }
}

export function* appSaga() {
  yield takeLatest(FETCH_TOKEN_DETAILS_REQUEST, getUserTokenDetails);
}

export default function* rootSaga() {
  yield all([appSaga()]);
}
